<div
  *ngIf="tripType && cmsAppCopy"
  class="modify-search-criteria row justify-content-between align-items-center"
  [ngClass]="{'disabled' : disabled}"
  (click)="modify()"
>
  <div class="col-10">
    <div class="row row-cols-1">
      <div *ngIf="searchInput && tripType !== TripType.multiCity" class="col col-md-auto top-row mb-md-0">
        <span class="fw-bold">
          {{ stationName(searchInput.criteria[0]?.origin) }}
        </span>
        <span> {{ cmsAppCopy.toCopy }} </span>
        <span class="fw-bold">
          {{ stationName(searchInput.criteria[0]?.destination) }}
        </span>
      </div>
      <div class="col col-md-auto align-items-center d-flex">
        @if (tripType !== TripType.multiCity) {
          <i class="fa fa-circle dot d-none d-md-inline mx-1" [ngClass]="{'disabled' : disabled}"></i>
        }
        <span>{{ cmsAppCopy[tripType] }}</span>
        <i class="fa fa-circle dot mx-1" [ngClass]="{'disabled' : disabled}"></i>
        <span>{{ travelers }}</span>
      </div>
    </div>
  </div>
  <div class="col-1 fs-3 d-flex justify-content-end">
    <i class="fa-light fa-sliders"></i>
  </div>
</div>
